import React from 'react';
import { Badge, ListGroup, Modal, Button } from 'react-bootstrap';

import momencik from '../../../common/momencik';
import { GetEmailDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { EmailStatus } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../translations';

import { EmailStatusIcon } from './EmailStatusIcon';
import { EmailPreviewLink } from './EmailPreviewLink';

interface EmailHistoryModalProps {
  show: boolean;
  onHide: () => void;
  emails: GetEmailDto[];
  currentEmailId: string;
}

export const EmailHistoryModal: React.FC<EmailHistoryModalProps> = props => {
  const { t, tk } = useTranslation('applicationLng');

  return (
    <Modal show={props.show} onHide={props.onHide} centered size="lg">
      <Modal.Header closeButton className="border-0 bg-light">
        <Modal.Title>{t(tk.email.history)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.emails.length === 0 ? (
          <div className="text-muted">{t(tk.email.noHistory)}</div>
        ) : (
          <ListGroup variant="flush">
            {[...props.emails].map(email => {
              const isCurrent = email.id === props.currentEmailId;
              const isResend = !!email.parentEmailId;
              return (
                <ListGroup.Item
                  key={email.id}
                  className={
                    isCurrent
                      ? 'd-flex align-items-center gap-3 bg-light'
                      : 'd-flex align-items-center gap-3'
                  }
                >
                  <EmailStatusIcon
                    status={email.status as unknown as EmailStatus}
                    t={t}
                  />
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <span className="fw-semibold">
                        {momencik(email.sendDate, 'YYYY-MM-DD HH:mm:ss')}
                      </span>
                      {!isResend && (
                        <Badge bg="secondary">{t(tk.email.original)}</Badge>
                      )}
                      {isCurrent && (
                        <Badge bg="primary">{t(tk.email.currentEmail)}</Badge>
                      )}
                    </div>
                    <div className="text-muted small text-truncate">
                      {email.sentTo}
                    </div>
                  </div>
                  <EmailPreviewLink emailId={email.id} />
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 bg-light pt-0">
        <Button variant="outline-secondary" onClick={props.onHide}>
          {t(tk.button.close)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
